import LineCharts from "./LineChart";
import React, { useState } from "react";

const KPIIndicator = ({
  title,
  value,
  threshold,
  modalChart,
  data,
  setModalChart,
  dark,
}) => {
  const [HPIChart, setHPIChart] = useState(null);

  return (
    <div className="d-flex flex-row">
      <div className="d-flex flex-row">
        <span class="me-2 text-main badge">{title}:</span>
        <span
          className={`cursor-pointer badge badge-secondary ${
            title === "Total No. People"
              ? value / threshold < 0.5
                ? "bg-good"
                : value / threshold === 0.5
                ? "bg-unhealthy-sensitive"
                : "bg-hazardous"
              : title === "Total Entry"
              ? "bg-entry"
              : title === "Total Exit"
              ? "bg-exit"
              : title === "Avg. Utilization" && value > threshold
              ? "bg-good"
              : "bg-unhealthy-sensitive"
          }`}
        >
          {title==="Avg. Utilization"? `${value}%`:value}
        </span>
      </div>
    </div>
  );
};

export default KPIIndicator;
